export default "__VITE_ASSET__Dgy16C7a__"